/**
 * Calculates the time difference between two date strings in seconds
 * @param {string} dateStr1 - Start date string
 * @param {string} dateStr2 - End date string
 * @returns {number} - Difference in seconds (rounded up)
 */
export const getTimeDifferenceInSeconds = (dateStr1, dateStr2) => {
  // Parse date strings to Date objects
  const date1 = new Date(dateStr1)
  const date2 = new Date(dateStr2)

  // Calculate the difference in milliseconds
  const diffInMs = date2 - date1

  // Convert milliseconds to seconds
  const diffInSeconds = diffInMs / 1000

  return Math.ceil(diffInSeconds)
}

/**
 * Default modal style for DraggableWindow video playback
 */
export const modalStyle = {
  width: '300px',
  height: '250px',
  resize: 'both',
  overflow: 'auto',
  borderRadius: '6px',
  borderBottomRightRadius: '0',
  background: 'var(--common-black)',
  padding: '10px'
}

/**
 * Container style for video stream elements
 */
export const streamContainerStyle = {
  position: 'relative',
  display: 'flex',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
}
